export default {
    name: '包厢',
    url: '/admin/box', // rest接口表名
    query: '', // rest接口query参数
    // 列表渲染列
    columns: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {title: '包厢', dataIndex: 'name'},
        ]
    },
    // 列表查询表单
    queryForm: [
        {
            key: 'name',
            label: '',
            component: 'a-input',
            props: {
                placeholder: '输入包厢名称查询',
            },
        },
    ],
    // 新增/编辑查询表单
    items: [
        {
            key: 'name',
            label: '包厢名称',
            component: 'a-input',
            props: {
                placeholder: '请输入包厢名称',
            },
            rules: [{ required: true, message: '请输入包厢名称', trigger: 'blur' }]
        },
    ],
    // 详情接口expand字段
    expand: '',
    init: {}, // 新增实体初始化字段
    // 详情渲染字段
    renderItems: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {
                label: '包厢名称',
                key: 'name',
            },
        ]
    }
}
